import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MultiLoginComponent } from './multi-login.component';
import { ActivationComponent } from './components/activation/activation.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';

import { LanguageModule } from '../language/language.module';
import { MultiLoginRoutingModule } from './multi-login-routing.module';
import { LoginComponent } from './components/login/login.component';
import { LoginCandidateComponent } from './components/login-candidate/login-candidate.component';
import { RegisterComponent } from './components/register/register.component';

import { NgaModule } from '../../theme/nga.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';
import { DndModule } from 'ng2-dnd';

import {
  ButtonModule,
  SplitButtonModule,
  GrowlModule,
  MessagesModule,
  InputTextModule,
  PasswordModule,
  SlideMenuModule,
  FileUploadModule,
  DataTableModule,
  SharedModule,
  InputTextareaModule,
  DropdownModule,
  ChipsModule,
  DialogModule,
  RatingModule,
  ConfirmDialogModule,
  ConfirmationService,
  InputMaskModule,
  GMapModule,
  CheckboxModule,
  MultiSelectModule,
  AutoCompleteModule,
  SelectButtonModule,
  InputSwitchModule,
  ChartModule,
  ToggleButtonModule,
  AccordionModule,
  PanelModule,
  FieldsetModule,
  CalendarModule,
  TabViewModule,
  StepsModule,
  LightboxModule,
  TooltipModule,
  EditorModule,
  RadioButtonModule,
  ProgressBarModule,
} from 'primeng/primeng';

import { SidebarModule } from 'primeng/components/sidebar/sidebar';
import {ScheduleModule} from 'primeng/components/schedule/schedule';

import { NgxChartsModule } from '@swimlane/ngx-charts';

import { StoreModule } from '@ngrx/store';

import { Angular2PromiseButtonModule } from 'angular2-promise-buttons/dist';

import { AgmCoreModule } from '@agm/core';

import { HttpModule, Http, RequestOptions } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { RecoverPasswordCandidateComponent } from './components/login-candidate/recover-password-candidate/recover-password-candidate.component';
import { ChangePasswordComponent } from '../employee/pages/change-password/change-password.component';

export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, '/assets/i18n/', '.po');
}

@NgModule({
  imports: [
    CommonModule,
    MultiLoginRoutingModule,
    LanguageModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    ButtonModule,
    SplitButtonModule,
    GrowlModule,
    MessagesModule,
    InputTextModule,
    PasswordModule,
    SlideMenuModule,
    FileUploadModule,
    DataTableModule,
    SharedModule,
    InputTextareaModule,
    DropdownModule,
    ChipsModule,
    DialogModule,
    RatingModule,
    ConfirmDialogModule,
    InputMaskModule,
    GMapModule,
    CheckboxModule,
    MultiSelectModule,
    AutoCompleteModule,
    SelectButtonModule,
    InputSwitchModule,
    ChartModule,
    ToggleButtonModule,
    AccordionModule,
    PanelModule,
    CalendarModule,
    TabViewModule,
    StepsModule,
    LightboxModule,
    TooltipModule,
    EditorModule,
    RadioButtonModule,
    FieldsetModule,
    SidebarModule,
    ScheduleModule,
    ProgressBarModule,
    Angular2PromiseButtonModule.forRoot({
        spinnerTpl: '<i class="fa fa-circle-o-notch fa-spin fa-fw btn-load"></i>',
        disableBtn: true,
        btnLoadingClass: 'is-loading',
        handleCurrentBtnOnly: false,
    }),
    NgaModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD041mK0SKDmCT9s6gaZ3XAq-psuHgA_Ec',
      libraries: ['places']
    }),
    StoreModule.forRoot({
    }),
    InfiniteScrollModule,
    NgxChartsModule,
    Angular2FontawesomeModule,
    DndModule,
  ],
  declarations: [
    LoginComponent,
    LoginCandidateComponent,
    ChangePasswordComponent,
    RecoverPasswordCandidateComponent,
    RegisterComponent,
    MultiLoginComponent,
    ActivationComponent,
    RecoverPasswordComponent,
  ]
})
export class MultiLoginModule { }





// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/multi-login/multi-login.module.ts